/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-logs-save-search-modal';
const prefix = `${moduleName}.${componentName}`;

export const saveSearchLabel = `${prefix}.saveSearchLabel`;
export const nameAlreadyExistsErrorLabel = `${prefix}.nameAlreadyExistsErrorLabel`;

export const ENGLISH = {
    [saveSearchLabel]: 'Save Search',
    [nameAlreadyExistsErrorLabel]: 'This search name already exists.',
};
